import {
  ActionSheet,
  Badge,
  Button,
  Calendar,
  Card,
  Cascader,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  CountDown,
  DatetimePicker,
  Dialog,
  Divider,
  Empty,
  Field,
  Form,
  GoodsAction,
  GoodsActionButton,
  GoodsActionIcon,
  Icon,
  Image,
  ImagePreview,
  Lazyload,
  List,
  Loading,
  NoticeBar,
  Notify,
  NumberKeyboard,
  PasswordInput,
  Picker,
  Popover,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Search,
  Step,
  Stepper,
  Steps,
  Sticky,
  SubmitBar,
  Swipe,
  SwipeItem,
  Switch,
  Tab,
  Tabs,
  Tag,
  Toast,
  TreeSelect,
  Uploader,
} from 'vant'

// 使用到的 vant 组件
export const usedVantComponents = {
  ActionSheet,
  Badge,
  Button,
  Card,
  Cell,
  CellGroup,
  Calendar,
  Checkbox,
  CheckboxGroup,
  CountDown,
  DatetimePicker,
  Dialog,
  Divider,
  Empty,
  Form,
  Field,
  GoodsAction,
  GoodsActionButton,
  GoodsActionIcon,
  Icon,
  Image,
  ImagePreview,
  Lazyload,
  List,
  Loading,
  NoticeBar,
  Notify,
  Popover,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Search,
  Step,
  Stepper,
  Steps,
  Sticky,
  SubmitBar,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Tag,
  Toast,
  TreeSelect,
  Uploader,
  Switch,
  Picker,
  PasswordInput,
  NumberKeyboard,
  Cascader,
}
